<!--
 * @Author: DY
 * @Date: 2024-12-02 17:52:20
 * @LastEditTime: 2024-12-25 10:56:13
 * @Description:
 * @FilePath: \ShiMo_Mobile\src\views\storage\crossWarehouseAllocationApply\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="crossWarehouseAllocationApply commonListStyles">
            <HeaderNav
                header-title="跨仓调拨管理"
                left-icon-name="2"
                right-icon-name="5"
                :extr="{ leftCallBack: swiperright, rightCallBack: addAllocation, iconName: 'sm-icon-test' }"
            ></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" @load="onLoad">
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">调拨单号：{{ item.TransferNo }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.Status | allocationStatus }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_46@2x.png" alt="">
                                            <span>物料代码：{{ item.MaterialCodes }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>短描述：{{ item.MaterialShortNames }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_6@2x.png" alt="">
                                            <span>调拨数量：{{ item.VolumeTransfer }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_3@2x.png" alt="">
                                            <span>调出仓库：{{ item.OutStockName }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_3@2x.png" alt="">
                                            <span>调入仓库：{{ item.InStockName }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>调拨确认时间：{{ item.OutStockConfirmTime }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <template v-if="item.Status === 0">
                                            <button @click="submitAllocation(item)">
                                                提交
                                            </button>
                                            <button @click="editAllocation(item, 'edit')">
                                                编辑
                                            </button>
                                        </template>
                                        <template v-else>
                                            <button @click="editAllocation(item, 'see')">
                                                查看
                                            </button>
                                        </template>
                                        <template v-if="![4,5].includes(item.Status)">
                                            <button @click="toVoidAllocation(item)">
                                                作废
                                            </button>
                                        </template>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'cross-warehouse-allocation-apply',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'cross-warehouse-allocation-apply');
        }
        next();
    },
    data() {
        return {
            requestUrl: '/procurement/stock_transfer/page_list/bpbj/transfer',
            initIndex: 1,
            pageIndex: 1,
            indexKey: 'PageIndex',
            sizeKey: 'PageSize',
        };
    },
    filters: {
        allocationStatus(val) {
            const status = ['待提交', '确认中', '确认中', '待出库', '已出库', '已作废'];
            return status[val];
        },
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    created() {
    },
    mounted() {},
    methods: {
        loadRequestData() {
            return {
                [this.indexKey]: this.pageIndex,
                [this.sizeKey]: this.pageSize,
                SearchKey: this.keyVal,
            };
        },

        addAllocation() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'allocationForm', params: { type: 'add' } });
        },

        async toVoidAllocation(item) {
            const res = await this.toVoidAllocationRequest(item.Id);
            if (res) {
                this.$toast.success('作废成功');
                this.onRefresh();
            }
        },

        async submitAllocation(item) {
            const res = await this.submitAllocationRequest(item.Id);
            if (res) {
                this.$toast.success('提交成功');
                this.onRefresh();
            }
        },

        editAllocation(item, type) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'allocationForm', params: { type, data: item } });
        },

        submitAllocationRequest(transferId) {
            return this.$axios.$put(`/interfaceApi/procurement/stock_transfer/transfer_submit/${transferId}`, {});
        },

        toVoidAllocationRequest(transferId) {
            return this.$axios.$put(`/interfaceApi/procurement/stock_transfer/cancel/${transferId}`, {});
        },
    },
};
</script>
<style lang="stylus">
.crossWarehouseAllocationApply
    section
        .van-pull-refresh
            height: calc(100% - 44rpx) !important
</style>
